/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { HgSupportedLanguage, TargetPlatform } from '@smg-real-estate/hg-search-libs';

export function urlNameByGeoIdResolver(store: any, targetPlatform: TargetPlatform) {
  return (locationId: string, language: HgSupportedLanguage): string | undefined => {
    const geoLocation = store.getters['geo/getGeoLocationById'](locationId);

    return targetPlatform === TargetPlatform.IMMOSCOUT24
      ? geoLocation?.is24UrlNames?.[language]
      : geoLocation?.urlNames[language];
  };
}
